import { useEffect } from "react";

export default function PaymentSuccess() {
  useEffect(() => {
    localStorage.setItem("license", "PRO"); // 🟦 salvăm licența
  }, []);

  return (
    <div style={{ padding: 50, textAlign: "center" }}>
      <h1 style={{ color: "green" }}>🎉 Payment Successful!</h1>
      <p>Your subscription is now active.</p>

      <button
        onClick={() => (window.location.href = "/backoffice")}
        style={{
          marginTop: 20,
          padding: "10px 20px",
          fontSize: 16,
          borderRadius: 8,
          border: "none",
          background: "#2563eb",
          color: "white",
          cursor: "pointer",
        }}
      >
        Go to Dashboard
      </button>
    </div>
  );
}
